/**
 * US Postal code regex.
 * Matches standard 5 digits or extend zip codes (5 digits followed by hyphen & 4 digits)
 * src: http://zparacha.com/validate-zip-code-using-javascript-regular-expression
 */

export default RegExp(/^\d{5}$|^\d{5}-\d{4}$/);
